/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import InputMask from 'react-input-mask';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { getGaleriaSecondByUser, getPlayerInfo, getResultadosByUser } from 'services/dashboard.service';
import { useAuth } from 'context/AuthContext';
import { ExtratoDetalheModal } from 'components/extrato-detalhe-modal';
import { useModal } from 'context/ModalContext';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Button from 'components/ui/button';
import {
  getMissaoEquipe,
  getMissaoEquipeEcoa,
  getMissaoGestor,
  getPointsHistory,
  getPointsSummary,
} from 'services/achievement.service';
import { PointItem } from 'components/point-item';
import { FormatNumber } from 'utils/helpers';
import { BsPlusLg } from 'react-icons/bs';
import ModalComment from 'components/modal-comment';
import Recognition from 'components/recognition';
import RecognitionReceived from 'components/recognitionReceived';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useLocation } from 'react-router-dom';
import ModalEdit from 'components/modal-edit';
import UserBadge from 'components/user-badge';
import { RealCycle } from 'types/user';
import Dimensions from './Component/Dimensions';
import CustomSelect from 'components/custom-select';
import { TbSearch } from 'react-icons/tb';
import { Summary } from './Component/Summary';
import { BiInfoCircle, BiMinus, BiFootball } from 'react-icons/bi';
import { PointReviewItem } from 'components/point-review-item';
import Timeline from './Component/Timeline';
import Tippy from '@tippyjs/react';
import { getLevelTitle } from 'services/utils';
import TabTitle from 'components/tab-title';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import PascoaExtratoItem from 'components/pascoa-extrato';
import { NewYearEnvelopeModal } from 'components/new-year-envelope-modal';
import cestoFechado from '../../assets/img/pascoa/cesto-fechado-novo.png';
import { actionLog, getMyPreference } from 'services/actionlog.service';
import { getGlobalConfig } from 'services/global.service';
import SurpriseBox from 'components/surprise-box';
import { FaEnvelope } from 'react-icons/fa';
import { MdCelebration } from 'react-icons/md';
import { CarnivalAiModal } from 'components/carnival-ai-modal';
import { getImgCarnaval, CarnivalImageData } from 'services/carnival.service';
import { CopaAlbumProvider, useCopaAlbumContext } from 'pages/Copa/CopaAlbumContext';
import { CopaThemePlayerProvider } from 'pages/Copa/CopaThemePlayerContext';
import { CopaModal } from 'pages/Copa/CopaModal';
import { EXTRATO_TABS, resolveExtratoTabs, shouldShowEcoaTab, TAB_ACOES_ECOA } from './extrato-tabs';

const menu = EXTRATO_TABS;
const menuRede = ['Resumo', 'Reconhecimentos'];

const TabsRede = ['Resumo', 'Reconhecimentos'];

interface TitleTabOptions {
  title: JSX.Element;
  hideFilter?: boolean;
  options: any;
  className?: string;
}

interface CyclePreferenceAttributes {
  task?: boolean;
  actions?: boolean;
  recognition?: boolean;
}

/**
 * Linha "Ver álbum" em Ações de Engajamento — acesso ao Álbum BB 2026 depois
 * do encerramento (RE-07), quando o modal/widget somem do Dashboard. Mesmo
 * padrão dos cards de Páscoa/Carnaval acima, mas a "carta" é o próprio
 * CopaModal (reaproveitado, só com a aba Pacote já removida — RE-07).
 *
 * Só aparece para quem participou (abriu ao menos 1 envelope): sem isso não
 * há o que ver no álbum. Precisa estar dentro de <CopaAlbumProvider> para ler
 * o estado do álbum e para o próprio CopaModal funcionar.
 */
function CopaAlbumExtratoRow() {
  const { albumState, hasLoadedOnce } = useCopaAlbumContext();
  const [showAlbum, setShowAlbum] = useState(false);

  const hasParticipated = hasLoadedOnce && albumState.repository.length > 0;
  if (!hasParticipated) return null;

  return (
    <div className="mt-6 bg-maastricht-blue-3 rounded-2xl py-8 px-12">
      <div className="flex flex-row space-x-3 items-center justify-between">
        <div className="flex flex-row space-x-3 items-center">
          <div className="w-[60px] h-[60px] relative flex items-center justify-center">
            <BiFootball size={40} className="text-yellow" aria-hidden="true" />
          </div>
          <div className="flex-1">
            <p className="text-gray-300 text-sm font-light mb-3">Álbum BB 2026</p>
            <p className="block text-base text-alice-blue m-0 font-normal">Veja sua escalação</p>
          </div>
        </div>
        <div className="flex flex-row space-x-3 items-center justify-center">
          <Button className="uppercase py-2 px-5 rounded w-auto" onClick={() => setShowAlbum(true)}>
            Ver álbum
          </Button>
        </div>
      </div>

      <CopaModal isOpen={showAlbum} onClose={() => setShowAlbum(false)} />
    </div>
  );
}

export default function Historico() {
  const [summaryList, setSummaryList] = useState<any>();
  const [list, setList] = useState<any[]>([]);
  const [sentList, setSentList] = useState<any[]>([]);
  const [pointsList, setPointsList] = useState<any[]>();
  const [culturaList, setCulturaList] = useState<any[]>();
  const [galeriaList, setGaleriaList] = useState<any[]>();
  const [options, setOptions] = useState<any>([]);

  const [missionList, setMissionList] = useState<unknown[]>();
  const [missionListEcoa, setMissionListEcoa] = useState<unknown[]>();

  const { user, userInfo, currentCycle, realCycle, cycleSelected } = useAuth();
  const { showModal } = useModal();
  const location = useLocation();
  const navigate = useNavigate();

  const [isGestor, setIsGestor] = useState(false);
  const searchRef = useRef<any>();

  const [loadingSummaryList, setLoadingSummaryList] = useState(true);
  const [loadingList, setLoadingList] = useState(true);
  const [loadingSentList, setLoadingSentList] = useState(true);
  const [loadingPointsList, setLoadingPointsList] = useState(true);
  const [loadingMissionList, setLoadingMissionList] = useState(true);
  const [loadingMissionListEcoa, setLoadingMissionListEcoa] = useState(true);
  const [loadingCulturaList, setLoadingCulturaList] = useState(true);
  const [loadingGaleriaList, setLoadingGaleriaList] = useState(true);
  const [withLimit, setWithLimit] = useState(false);

  const [recognitionTab, setRecognitionTab] = useState<'RECEIVED' | 'SENDED'>('RECEIVED');

  const [showSummary, setShowSummary] = useState(false);
  const [summaryData, setSummaryData] = useState<{
    title?: string;
    data: any;
    type?: string;
  }>();

  const [activeEditModal, setActiveEditModal] = useState<{
    message: string;
    id: string;
  } | null>();
  const [editMessage, setEditMessage] = useState<{
    message: string;
    id: string;
  } | null>();

  const [activeTab, setActiveTab] = useState(0);

  const [filter, setFilter] = useState({});
  const [realCycleFilter, setRealCycleFilter] = useState<any>();
  const [cyclePreference, setCyclePreference] = useState<CyclePreferenceAttributes | null>(null);
  const [showModalCardPascoa, setShowModalCardPascoa] = useState(false);
  const [globalConfig, setGlobalConfig] = useState<any>();
  const [carnivalData, setCarnivalData] = useState<CarnivalImageData | null>(null);
  const [loadingCarnivalData, setLoadingCarnivalData] = useState(false);
  const showEcoaTab = shouldShowEcoaTab({ userInfoEcoa: userInfo?.ecoa, acaoEcoa: summaryList?.acao_ecoa });
  const extratoTabs = useMemo(
    () => resolveExtratoTabs({ tipoDeAcordo: userInfo?.tipo_de_acordo, showEcoaTab }),
    [userInfo?.tipo_de_acordo, showEcoaTab],
  );

  function handleDetail(item: any) {
    showModal('extrato-detalhe', item);
  }

  function showCardEaster() {
    setShowModalCardPascoa(true);
    actionLog(
      'me',
      'easter',
      {
        interaction: 'ver_cartao',
      },
      null,
      null,
      null,
      false,
    );
  }

  function showCardNewYear() {
    showModal && showModal('new-year-envelope-direct');
  }

  async function loadCarnivalData() {
    setLoadingCarnivalData(true);
    try {
      const data = await getImgCarnaval();
      setCarnivalData(data);
    } catch (error) {
      console.error('Erro ao carregar dados do carnaval:', error);
      setCarnivalData(null);
    } finally {
      setLoadingCarnivalData(false);
    }
  }

  function getMissaoDestaque() {
    if (isGestor) {
      const valoracao = summaryList?.missao_destaque_gestor || 0;
      const participacao = summaryList?.missao_destaque_equipe || 0;
      return FormatNumber(valoracao + participacao);
    } else {
      return FormatNumber(summaryList?.missao_destaque_equipe);
    }
  }

  const title = useMemo(() => {
    switch (activeTab) {
      case 0:
        return (
          <>
            Seu Extrato <span className="text-md lg:text-[22px] font-bold text-yellow">Joga Junto BB</span>
          </>
        );
      case 1:
        return <>Reconhecimentos</>;
      case 2:
        return (
          <>
            Realizações Destaque{' '}
            <span className="text-xl lg:text-[22px] font-bold text-yellow ">({missionList?.length || 0})</span>
          </>
        );
      case 3:
        return (
          <>
            Ações ECOA <span className="text-xl lg:text-[22px] font-bold text-yellow ">({missionListEcoa?.length || 0})</span>
          </>
        );

      case 4:
        return (
          <>
            Ações de Engajamento{' '}
            <span className="text-xl lg:text-[22px] font-bold text-yellow ">({pointsList?.length || 0})</span>
          </>
        );

      default:
        return <></>;
    }
  }, [activeTab, missionList, pointsList]);

  useEffect(() => {
    async function loadData() {
      const playerInfo = userInfo;

      if (playerInfo) {
        setIsGestor(
          playerInfo.tipo_ro === 'GERENCIAL' ||
            playerInfo.funcao === 'DIRETOR' ||
            (Array.isArray(playerInfo.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => typeof md.tipo_ro === 'string' && md.tipo_ro === 'GERENCIAL')),
        );
      }
    }

    if (user && realCycle) {
      initFilter();
      loadData();
    }
  }, [user, realCycle]);

  function initFilter() {
    if (!!realCycle) {
      const _cycles = realCycle.map((item: any) => {
        item.label = item.title;
        item.value = item._id;
        return item;
      });

      setOptions(_cycles);
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const active = searchParams.get('active');
    const sub = searchParams.get('sub') as 'RECEIVED' | 'SENDED';

    if (active) {
      setActiveTab(Number(active));
      searchParams.delete('active');
      const newUrl = window.location.pathname + '?' + searchParams.toString();
      window.history.replaceState({}, '', newUrl);

      if (sub) {
        setRecognitionTab(sub);
        searchParams.delete('sub');
        const newUrl = window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({}, '', newUrl);
      }
    }
  }, [location]);

  useEffect(() => {
    setShowSummary(false);
    setSummaryData(undefined);
  }, [activeTab]);

  /**
   * O resumo do ciclo carrega por CICLO, não por aba: além de alimentar a aba
   * Resumo, é dele que sai a visibilidade da aba ECOA de quem não tem o perfil
   * no player info. Preso à aba Resumo, trocar de ciclo estando em outra aba
   * deixava a barra de abas defasada.
   */
  useEffect(() => {
    async function loadSummary() {
      try {
        const data = await getPointsSummary(user?._id, currentCycle?.date_start, currentCycle?.date_finish, filter);
        setSummaryList(data);

        setWithLimit(data?.pontos_bonus?.total + data?.acao_ecoa?.total >= 4000);

        const preferenceData = await getMyPreference(realCycleFilter?.value);

        if (!Array.isArray(preferenceData) || preferenceData.length === 0) {
          setCyclePreference(null);
        } else {
          const latestPreference = preferenceData[0];
          setCyclePreference(latestPreference?.attributes || null);
        }

        setLoadingSummaryList(false);
      } catch (e) {}
    }

    if (user && !!currentCycle && !!realCycleFilter) {
      loadSummary();
    }
  }, [user, currentCycle, realCycleFilter, filter]);

  useEffect(() => {
    async function loadData() {
      try {
        if (activeTab === 1) {
        } else if (activeTab === 2) {
          setLoadingMissionList(true);
          const dataGestor = await getMissaoGestor(user?._id, realCycleFilter?.value);
          const dataEquipe = await getMissaoEquipe(user?._id, realCycleFilter?.value, filter);
          setMissionList([...dataGestor, ...dataEquipe]);

          setLoadingMissionList(false);
        } else if (activeTab === 3) {
          setLoadingMissionListEcoa(true);
          const dataEquipe = await getMissaoEquipeEcoa(user?._id, realCycleFilter?.value, filter);
          setMissionListEcoa(dataEquipe);

          setLoadingMissionListEcoa(false);
        } else if (activeTab === 4) {
          setLoadingPointsList(true);
          const data = await getPointsHistory(user?._id, '', '', filter);

          setPointsList(data);
          setLoadingPointsList(false);
        }
      } catch (e) {}
    }

    if (user && !!currentCycle && !!realCycleFilter) {
      loadData();
    }
  }, [user, activeTab, searchRef, currentCycle, filter]);

  useEffect(() => {
    if (user?.extra.rede) {
      setActiveTab(1);
    }
  }, [user]);

  // Trocar de ciclo pode esconder a aba ECOA; sem isso o extrato ficaria numa
  // aba que não existe mais na barra. Só decide depois que o resumo do ciclo
  // chegou — antes disso ainda não se sabe se a aba existe.
  useEffect(() => {
    if (summaryList && !showEcoaTab && activeTab === TAB_ACOES_ECOA) {
      setActiveTab(0);
    }
  }, [summaryList, showEcoaTab, activeTab]);

  useEffect(() => {
    if (user?._id) {
      loadCarnivalData();
    }
  }, [user?._id]);

  function setActiveTabFiltered(index: number) {
    setActiveTab(extratoTabs.indexMap[index]);
  }

  function getActiveTabFiltered(index: number) {
    return activeTab === extratoTabs.indexMap[index];
  }

  useEffect(() => {
    if (cycleSelected) {
      if (cycleSelected.version) {
        navigate(`/${cycleSelected.version}/extrato`);
      }
    }
  }, [cycleSelected]);

  function scrollTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  function showPreferenceMessage(type: keyof CyclePreferenceAttributes) {
    return cyclePreference?.[type] === false;
  }

  const EmptyResult = () => {
    return (
      <>
        <div className="space-y-2 flex justify-center">
          <p className="text-white font-bold text-center text-2xl" tabIndex={0}>
            Não há registros para esse ciclo.
          </p>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex items-center justify-between mb-10">
          <div className="flex flex-ro items-center space-x-3 ">
            <div>
              <Link to="../" tabIndex={-1}>
                <button
                  className="rounded-full bg-purple flex justify-center items-center p-1"
                  tabIndex={0}
                  aria-label="Botão de voltar"
                >
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>
            <h1 className="text-xl lg:text-3xl" tabIndex={0}>
              Extrato Completo
            </h1>
          </div>
        </div>

        {options?.length > 0 && (
          <TabTitle
            title={title}
            options={options}
            key={1}
            onCallBack={e => [setShowSummary(false), setFilter({ ...filter, ...{ cycleId: e?.value } }), setRealCycleFilter(e)]}
          />
        )}

        {!user?.extra.rede ? (
          <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 hidden lg:flex">
            {extratoTabs.labels.map((item: string, index: number) => (
              <button
                key={item}
                aria-label={`${getActiveTabFiltered(index) ? 'selecionado' : ''}  ${item}`} // eslint-disable-line
                className={`${
                  getActiveTabFiltered(index) ? 'bg-slate-blue' : 'bg-maastricht-blue'
                } w-6/12 h-[86px] text-xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-all`}
                onClick={() => [setActiveTabFiltered(index)]}
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              ></button>
            ))}
          </div>
        ) : (
          <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 hidden lg:flex">
            {TabsRede.map((item: string, index: number) => (
              <button
                aria-label={`${activeTab === index ? 'selecionado' : ''}`}
                className={`${
                  activeTab === index ? 'bg-slate-blue' : 'bg-maastricht-blue'
                } w-6/12 h-[86px] text-xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-all`}
                onClick={() => [setActiveTab(index)]}
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              ></button>
            ))}
          </div>
        )}

        <div className="flex justify-between items-center lg:hidden mb-10">
          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={activeTab < 1}
            onClick={() => setActiveTab(activeTab - 1)}
          >
            <IoIosArrowBack className={`text-grey-dark ${activeTab === 0 && 'bg-opacity-5'}}`} size={24} />
          </Button>

          <p
            className="text-xl font-bold text-yellow text-center"
            dangerouslySetInnerHTML={{
              __html: !user?.extra.rede ? menu[activeTab] : menuRede[activeTab],
            }}
          ></p>

          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={activeTab > 3}
            onClick={() => setActiveTab(activeTab + 1)}
          >
            <IoIosArrowForward className={`text-grey-dark ${activeTab > 0 && 'opacity-5'}}`} size={24} />
          </Button>
        </div>

        {activeTab === 0 && (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingSummaryList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingSummaryList && (
                <div className="space-y-2">
                  {/* Substituir a próxima linha quando houverem mais itens */}
                  {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}

                  {realCycleFilter && (realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024') && (
                    <div className="-mt-10">
                      <h3 className="flex items-center text-[19px] mb-0">
                        Nível:{''}
                        <span className="ml-2 font-bold text-yellow flex items-center">
                          {getLevelTitle(summaryList?.level?.nivel)}{' '}
                          <Tippy
                            arrow={true}
                            allowHTML={true}
                            className="bg-black text-white font-thin rounded-xl p-2 tippy"
                            content={<>Nível definido.</>}
                          >
                            <div className="ml-2" tabIndex={0} aria-label={`Nível definido.`}>
                              <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                            </div>
                          </Tippy>
                        </span>
                      </h3>

                      <h3 className="flex items-center text-[19px] -mt-3 mb-10">
                        <button className="flex items-center" onClick={() => showModal('group-detail-extrato')}>
                          Grupo:{''}
                          <span className="ml-2 font-bold text-yellow flex items-center">
                            {summaryList?.level?.grupo}{' '}
                            <Tippy
                              arrow={true}
                              allowHTML={true}
                              className="bg-black text-white font-thin rounded-xl p-2 tippy"
                              content={<>O seu grupo de classificação está definido.</>}
                            >
                              <div className="ml-2" tabIndex={0} aria-label={`O seu grupo de classificação está definido.`}>
                                <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                              </div>
                            </Tippy>
                          </span>
                        </button>
                      </h3>
                    </div>
                  )}

                  <div className="grid grid-cols-1 gap-4">
                    <div
                      className="bg-maastricht-blue-3 rounded-2xl py-8 px-12 flex flex-col lg:flex-row lg:items-center justify-between"
                      tabIndex={0}
                      aria-label={`Total de Pontos do Ciclo: ${summaryList.total} pontos`}
                    >
                      <div>
                        <div className="text-yellow mb-2 text-base">Total de Pontos do Ciclo</div>
                        <div className="text-3xl">
                          <b>{FormatNumber(summaryList.total)}</b> <small className="text-base">pontos</small>
                        </div>
                      </div>
                    </div>

                    {!user?.extra.rede && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Reconhecimentos recebidos: ${summaryList?.reconhecimentos.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Reconhecimentos recebidos</div>

                            {showPreferenceMessage('recognition') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList?.reconhecimentos.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>

                          {summaryList?.reconhecimentos.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(1);
                                // if (showSummary && summaryData?.type === 'recognition') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.reconhecimentos.summary,
                                //     title: 'Histórico de reconhecimentos recebidos',
                                //     type: 'recognition',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'recognition' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'recognition' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'recognition' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {!user?.extra.rede && userInfo?.tipo_de_acordo === 'HIBRIDO' && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Realização Destaque: ${summaryList.realizacao_destaque.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Realização Destaque</div>

                            {showPreferenceMessage('task') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.realizacao_destaque.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.realizacao_destaque.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(2);
                                // if (showSummary && summaryData?.type === 'realization') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.realizacao_destaque.summary,
                                //     title: 'Histórico de realizações pontuadas',
                                //     type: 'realization',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'realization' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'realization' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'realization' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {!user?.extra.rede && showEcoaTab && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Ação ECOA: ${summaryList.acao_ecoa.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Ação ECOA</div>

                            {showPreferenceMessage('actions') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.acao_ecoa.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.acao_ecoa.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(3);
                                // if (showSummary && summaryData?.type === 'acao_ecoa') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.acao_ecoa.summary,
                                //     title: 'Histórico de realizações pontuadas',
                                //     type: 'acao_ecoa',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'acao_ecoa' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'acao_ecoa' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'acao_ecoa' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {summaryList?.destaques_cultura?.total ? (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12 flex flex-col lg:flex-row lg:items-center justify-between">
                        <div>
                          <div className="text-yellow mb-2 text-base">Destaque da cultura</div>
                          <div className="text-3xl">
                            <b>{FormatNumber(summaryList?.destaques_cultura?.total)}</b>{' '}
                            <small className="text-base">pontos</small>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {!user?.extra.rede && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Ações, Desafios e Campanhas: ${summaryList?.pontos_bonus.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Ações de Engajamento</div>

                            {showPreferenceMessage('actions') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            {withLimit && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme IN 403-1 item 6.5.6.4.3.1.1 A quantidade máxima de pontos em Ações de Engajamento por
                                funcionário será de 4.000 (quatro mil) pontos por semestre.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.pontos_bonus.total || 0, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.pontos_bonus.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(4);
                                // if (showSummary && summaryData?.type === 'action') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.pontos_bonus.summary,
                                //     title: 'Histórico de desafios pontuados',
                                //     type: 'action',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'action' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}
                              <span className="uppercase text-grey-dark">
                                {showSummary && summaryData?.type === 'action' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'action' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 1 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              <div className="w-full lg:flex-row">
                <div className="flex items-center m-0">
                  <button
                    aria-label={`${
                      recognitionTab === 'RECEIVED' ? 'Reconhecimentos recebidos Selecionado' : 'Reconhecimentos recebidos '
                    }`}
                    className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                      recognitionTab === 'RECEIVED'
                        ? 'bg-electric-blue text-maastricht-blue border-transparent'
                        : 'bg-transparent text-white border-white'
                    }`}
                    onClick={e => {
                      setRecognitionTab('RECEIVED');
                    }}
                  >
                    Recebidos
                  </button>
                  <button
                    aria-label={`${
                      recognitionTab === 'SENDED' ? 'Reconhecimentos Enviados Selecionado' : 'Reconhecimentos Enviados '
                    }`}
                    className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                      recognitionTab === 'SENDED'
                        ? 'bg-electric-blue text-maastricht-blue border-transparent'
                        : 'bg-transparent text-white border-white'
                    }`}
                    onClick={e => {
                      setRecognitionTab('SENDED');
                    }}
                  >
                    Enviados
                  </button>
                </div>
                <div className="mt-14">
                  {recognitionTab === 'RECEIVED' && (
                    <>
                      {/* flex justify-between items-center */}
                      <div className="flex flex-col pb-20 lg:pb-0 w-full my-14">
                        <div className="flex flex-col items-start justify-start lg:flex-row lg:justify-between lg:items-center">
                          <h3 className="text-white font-bold text-xl mb-4 lg:mb-0" tabIndex={0}>
                            Dimensões do Comportamento
                          </h3>
                        </div>
                        <Dimensions filter={filter} />
                      </div>
                      <RecognitionReceived filter={filter} />
                    </>
                  )}
                  {recognitionTab === 'SENDED' && (
                    <Recognition
                      message={editMessage}
                      filter={filter}
                      activeModal={item => {
                        setActiveEditModal(item);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {activeTab === 2 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingMissionList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingMissionList && missionList && missionList.length > 0 ? (
                <>
                  {/* TIMELINE DO EXTRATO */}
                  {realCycleFilter && (realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024') && (
                    <Timeline data={missionList} cycle={realCycleFilter?.value} />
                  )}
                  <div className="space-y-2">{missionList?.map((item: any) => <PointItem key={item._id} data={item} />)}</div>
                </>
              ) : null}
              {!loadingMissionList && missionList?.length === 0 && <EmptyResult />}
            </div>
          </div>
        ) : null}

        {activeTab === 3 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingMissionListEcoa && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingMissionListEcoa && missionListEcoa && missionListEcoa.length > 0 ? (
                <>
                  <div className="space-y-2">
                    {missionListEcoa?.map((item: any) => (
                      <PointItem cycleLabel={realCycleFilter?.label} key={item._id} data={item} />
                    ))}
                  </div>
                </>
              ) : null}
              {!loadingMissionListEcoa && missionListEcoa?.length === 0 && <EmptyResult />}
            </div>
          </div>
        ) : null}

        {activeTab === 4 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingPointsList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingPointsList && pointsList && pointsList.length > 0 ? (
                <div className="space-y-2">
                  {pointsList.map((item: any) => (
                    <PointItem key={item._id} data={item} cycleLabel={realCycleFilter?.label} />
                  ))}
                </div>
              ) : null}
              {/* APENAS MOSTRAR NO 1S2025 */}
              {!loadingPointsList && realCycleFilter?._id === '67ce6744ee5cff36a6f49426' && (
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between bg-maastricht-blue-3 p-3 lg:py-10 lg:px-16 space-y-5 lg:space-y-0 lg:space-x-3 rounded-xl">
                  <div className="flex flex-row space-x-3 items-center">
                    <div className="w-[60px] h-[60px] relative">
                      <img id="cesto" src={cestoFechado} alt="Cesto com ovo fechado" className="cesto" />
                    </div>
                    <div className="flex-1">
                      <p className="text-gray-300 text-sm font-light mb-3">Páscoa de Reconhecimento</p>
                      <p className="block text-base text-alice-blue m-0 font-normal">Veja seu cartão de reconhecimento</p>
                    </div>
                  </div>
                  <div className="flex flex-row space-x-3 items-center justify-center">
                    <Button className="uppercase py-2 px-5 rounded w-auto" onClick={showCardEaster}>
                      Ver cartão
                    </Button>
                  </div>

                  {showModalCardPascoa && <PascoaExtratoItem closeModal={() => setShowModalCardPascoa(false)} />}
                </div>
              )}

              {/* APENAS MOSTRAR NO 2S2025 */}
              {!loadingPointsList && realCycleFilter?._id === '68af4216458e527eaa782bec' && user?.extra?.actions !== false && (
                <div className="mt-6 bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                  <div className="flex flex-row space-x-3 items-center justify-between">
                    <div className="flex flex-row space-x-3 items-center">
                      <div className="w-[60px] h-[60px] relative">
                        <FaEnvelope size={40} className="text-yellow" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-300 text-sm font-light mb-3">Retrospectiva 2025</p>
                        <p className="block text-base text-alice-blue m-0 font-normal">Veja sua retrospectiva personalizada</p>
                      </div>
                    </div>
                    <div className="flex flex-row space-x-3 items-center justify-center">
                      <Button className="uppercase py-2 px-5 rounded w-auto" onClick={showCardNewYear}>
                        Ver cartão
                      </Button>
                    </div>
                  </div>
                </div>
              )}

              {/* APENAS MOSTRAR NO 1S2026 */}
              {!loadingPointsList &&
                carnivalData &&
                (carnivalData.latest || carnivalData.latestGenerated) &&
                realCycleFilter?._id === '698658dc458e527eaa43981c' && (
                  <div className="mt-6 bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                    <div className="flex flex-row space-x-3 items-center justify-between">
                      <div className="flex flex-row space-x-3 items-center">
                        <div className="w-[60px] h-[60px] relative flex items-center justify-center">
                          <MdCelebration size={40} className="text-yellow" />
                        </div>
                        <div className="flex-1">
                          <p className="text-gray-300 text-sm font-light mb-3">Carnaval Joga Junto</p>
                          <p className="block text-base text-alice-blue m-0 font-normal">Veja sua imagem de perfil do Carnaval</p>
                        </div>
                      </div>
                      <div className="flex flex-row space-x-3 items-center justify-center">
                        <Button className="uppercase py-2 px-5 rounded w-auto" onClick={() => showModal('carnival-ai')}>
                          Ver cartão
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

              {/* Álbum BB 2026 — acesso pós-encerramento (RE-07), aba Pacote já removida */}
              {!loadingPointsList && user?.extra?.actions !== false && (
                // cycleId = cycleSelected (o mesmo que o Dashboard usa para o
                // CopaModal/widget) — NÃO o realCycleFilter (ciclo que o
                // Extrato está exibindo/navegando). São conceitos diferentes:
                // o álbum é do ciclo ATUAL do jogador, independente de qual
                // ciclo histórico ele está olhando no Extrato.
                <CopaAlbumProvider cycleId={cycleSelected?._id}>
                  <CopaThemePlayerProvider>
                    <CopaAlbumExtratoRow />
                  </CopaThemePlayerProvider>
                </CopaAlbumProvider>
              )}
              {/* {!loadingPointsList && pointsList?.length === 0 && <EmptyResult />} */}
            </div>
          </div>
        ) : null}
      </div>

      <GroupDetailModalExtrato cycleLabel={realCycleFilter?.label} />

      <ExtratoDetalheModal />

      {/* Mount New Year modal so it can open via ModalContext */}
      <NewYearEnvelopeModal />

      <CarnivalAiModal carnivalData={carnivalData} onImageGenerated={loadCarnivalData} />

      {activeEditModal && (
        <ModalEdit
          close={() => setActiveEditModal(null)}
          data={activeEditModal}
          sendMessage={message => {
            setEditMessage(message);
            setActiveEditModal(null);
          }}
        />
      )}
    </>
  );
}
